<template>
  <div class="animated fadeIn" v-if="pageLoaded">
    <b-card style="border: 0" class="mt-0 mb-0">
      <b-card
        v-if="
          role == 'researcher' &&
          (status == 'نیاز به تکمیل / اصلاح' || status == 'پیش نویس') &&
          adminMessage
        "
        header-bg-variant="danger"
        header-text-variant="white"
        header="اصلاحات مورد نیاز"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
        >{{ adminMessage }}</b-card
      >
      <b-card
        v-if="
          (role == 'researcher' || role == 'admin') && status == 'رد شده است'
        "
        header-bg-variant="danger"
        header-text-variant="white"
        header="دلایل رد"
        style="border: 0"
        class="shadow p-3 mb-5 bg-white rounded mt-0"
      >
        <ul>
          <li v-for="message in rejections" :key="message">- {{ message }}</li>
        </ul>
        <br />
      </b-card>
      <h3>کد درخواست ریزپروژه طرح کلان: {{ requestsCode }}</h3>
      <h4 class="text-dark">وضعیت درخواست ریزپروژه طرح کلان: {{ status }}</h4>
      <hr />

      <b-tabs pills v-model="tabIndex">
        <b-tab title="چکیده درخواست" active lazy>
          <b-card no-body class="mb-">
            <b-card-body>
              <b-card-text class="shadow p-4">
                <ul>
                  <li :class="faSubject ? 'done' : 'required'">
                    <b>عنوان طرح کلان به زبان فارسی:</b> {{ faSubject }}
                  </li>
                  <li :class="university ? 'done' : 'required'">
                    <b>نام دانشگاه:</b> {{ university }}
                  </li>
                  <li :class="researcher ? 'done' : 'required'">
                    <b>پژوهشگر:</b> {{ researcher }}
                  </li>
                  <li :class="proposalFile ? 'done' : 'required'">
                    <b>پروپزال:</b>
                    <br />
                    <span style="float: right"
                      ><a
                        class="btn btn-success white--text"
                        :href="proposalFile"
                        target="_blank"
                        >دریافت</a
                      ></span
                    >
                  </li>
                </ul>
              </b-card-text>
            </b-card-body>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'admin' && isArchive" title="نسخه‌های پیشین">
          <b-tabs vertical pills fill>
            <b-tab v-for="(old, index) in archives" :key="index">
              <template slot="title">
                <div class="d-flex flex-column align-items-center">
                  {{ "نسخه" + " " + Number(archives.length - index) }}
                  <p class="mb-0">({{ old.registerDate }})</p>
                </div>
              </template>
              <b-tabs pills>
                <b-card-text class="shadow p-4">
                  <ul>
                    <li :class="old.faSubject ? 'done' : 'required'">
                      <b>عنوان طرح کلان به زبان فارسی:</b>
                      {{ old.faSubject }}
                    </li>
                    <li :class="old.university ? 'done' : 'required'">
                      <b>نام دانشگاه:</b> {{ old.university }}
                    </li>
                    <li :class="old.researcher ? 'done' : 'required'">
                      <b>پژوهشگر:</b> {{ old.researcher }}
                    </li>
                    <li :class="old.proposalFile ? 'done' : 'required'">
                      <b>پروپزال:</b>
                      <br />
                      <span style="float: right"
                        ><a
                          class="btn btn-success white--text"
                          :href="old.proposalFile"
                          target="_blank"
                          >دریافت</a
                        ></span
                      >
                    </li>
                  </ul>
                </b-card-text>
              </b-tabs>
            </b-tab>
          </b-tabs>
        </b-tab>
        <b-tab v-if="role == 'admin'" title="تاریخچه">
          <!-- :text-variant="'white'" -->
          <b-card
            :bg-variant="computedVariant(index)"
            v-for="(p, index) in histories"
            :key="index"
            style="max-width: 80%"
            class="mb-3 border-0 shadow"
          >
            <template slot="header">
              <b-row>
                <b-col>
                  <h5>{{ p.name }}</h5>
                </b-col>
                <b-col>
                  <div style="float: left">
                    <h5>{{ p.date }}</h5>
                  </div>
                </b-col>
              </b-row>
            </template>

            <h6>{{ p.message }}</h6>
          </b-card>
        </b-tab>
        <b-tab v-if="role == 'admin'" title="مدیریت وضعیت">
          <b-form-group id="fieldset-1" label="وضعیت طرح">
            <b-form-group>
              <Select2
                v-model="decision"
                :options="situationsOptions"
                :settings="{ width: '75%' }"
              ></Select2>
            </b-form-group>
            <div v-if="decision == 2">
              <b-row>
                <i
                  class="fa fa-exclamation-triangle fa-2x text-warning ml-3"
                  aria-hidden="true"
                ></i>
                <p class="mt-2 ml-2 text-danger">
                  تذکر: لطفا توجه داشته باشد که متن نگارش شده توسط شما بدون
                  تغییر در اختیار کاربر قرار خواهد گرفت
                </p>
              </b-row>

              <b-form-textarea
                trim
                id="textarea"
                aria-describedby="adminMessage"
                v-model="adminMessage"
                width="75%"
                placeholder="نظرات خود را اینجا وارد نمایید"
                rows="8"
                max-rows="10"
              ></b-form-textarea>
              <b-form-invalid-feedback
                id="adminMessage"
                :state="adminMessage ? null : false"
                >با نوشتن نظر خود میتوانید دانشگاه را در انجام اصلاحات مورد نیاز
                راهنمایی کنید</b-form-invalid-feedback
              >
              <hr />
            </div>
            <b-form-group label="دلایل رد درخواست" v-else-if="decision == 6">
              <v-select
                multiple
                :reduce="(x) => x.code"
                :options="rejectOptions"
                v-model="rejectionIds"
              >
              </v-select>
            </b-form-group>
            <b-form-group label="یادداشت" class="mt-4">
              <b-form-textarea
                trim
                id="textarea"
                aria-describedby="description"
                v-model="description"
                width="75%"
                placeholder="نظرات خود را اینجا وارد نمایید"
                rows="8"
                max-rows="10"
              ></b-form-textarea>
            </b-form-group>
            <b-form-group>
              <b-button :disabled="disableSubmit" @click="submit()"
                >ثبت</b-button
              >
            </b-form-group>
          </b-form-group>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from "moment-jalaali";
const sarmadGantt = () => import("./sarmadGantt");
import Select2 from "v-select2-component";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "Researcher Uni Request",
  props: ["role"],
  components: {
    datePicker: VuePersianDatetimePicker,
    Select2,
    sarmadGantt: sarmadGantt,
  },
  data() {
    return {
      moment: moment,
      oldData: [],
      expireDisable: false,
      rejectCause: [],
      rejectOptions: [],
      myshow: false,
      selectedMehvar: 0,
      show: false,
      rejectMessage: "",
      fileBusy: true,
      situationsOptions: [
        { id: 1, eng: "registered", text: "ثبت شده" },
        { id: 2, eng: "incomplete", text: "نیاز به تکمیل / اصلاح" },
        { id: 3, eng: "corrected", text: "اصلاح شده" },
        { id: 4, eng: "approve", text: "پذیرش اولیه" },
        { id: 5, eng: "finalAccept", text: "تایید نهایی" },
        { id: 6, eng: "rejected", text: "رد شده است" },
        { id: 7, eng: "declined", text: "لغو" },
      ],
      oldInfo: {},
      source: "",
      reviews: [],
      haveReferee: null,
      contract: null,
      zone: new Array(6).fill(false),
      prof: {},
      pageLoaded: false,
      fileFilter: "",
      reviewerData: [],
      isSaving: false,
      selectedReviewer: {},
      color: "",
      tabIndex: 0,
      isLoaded: true,
      removeLoading: false,
      //----------------- Uni Request------------------//
      university: "",
      status: "",
      adminMessage: "",
      faSubject: "",
      proposalFile: "",
      researcher: "",
      revision: 0,
      requestsCode: "",
      exportDate: moment(new Date()).format("jDD/jMM/jYYYY"),
      registerDate: "",
      histories: [],
      decision: "",
      description: "",
      rejectionIds: [],
      rejections: [],
      isArchive: false,
      archives: [],
    };
  },

  methods: {
    viewList() {
      localStorage.setItem("list", "accelerator");
      let link = "/map";
      window.open(link, "_blank");
    },

    onMounted() {
      // NOTE (MOUNTED) to show the data of this page
      this.$bvModal.show("loading");
      this.isLoaded = false;
      this.$root.$emit("show::modal", "loading");

      this.busyAll = true;
      this.$http
        .post(
          this.baseUrl + "/setad/options/rejections",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.rejectOptions = res.data;
          this.rejectOptions.forEach((x) => {
            x.code = x.id;
            x.label = x.name;
          });
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
      if (this.role == "admin") {
        let acc = 0;
        this.$http
          .get(
            `${this.baseUrl}/setad/admin/researcherUniRequest/${this.$route.params.id}`,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.histories = res.data.history;
            this.isArchive = res.data.isArchive ? res.data.isArchive : false;
            this.archives = res.data.archives ? res.data.archives : [];
            const unirequest = res.data.researcherUniRequest;
            this.adminMessage = unirequest.adminMessage
              ? unirequest.adminMessage
              : "";
            this.faSubject = unirequest.faSubject;
            this.proposalFile = unirequest.proposalFile;
            this.registerDate = unirequest.registerDate;
            this.requestsCode = unirequest.requestsCode
              ? unirequest.requestsCode
              : "";
            this.researcher = unirequest.researcher;
            this.revision = unirequest.revision ? unirequest.revision : 0;
            this.rejectionIds = unirequest.rejectionIds
              ? unirequest.rejectionIds.map((x) => x._id)
              : [];
            this.university = unirequest.university;
            this.status = unirequest.status;
            this.rejections = unirequest.rejectionIds
              ? unirequest.rejectionIds.map((x) => x.name)
              : [];

            setTimeout(() => {
              // NOTE (m-setTimeout) to set timeout for 200 ms
              this.$bvModal.hide("loading");
              this.isLoaded = true;
              this.pageLoaded = true;
              this.show = true;
            }, 200);
            acc++;
            if (acc > 2) {
              try {
                document.body.classList.toggle("sidebar-minimized");
                document.body.classList.toggle("brand-minimized");
                this.toast(
                  "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
                );
              } catch (err) {
                console.log(err);
              }
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else if (this.role == "researcher") {
        this.$http
          .get(
            `${this.baseUrl}/setad/researcher/uniRequest/${this.$route.params.id}`,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            const unirequest = res.data;
            this.adminMessage = unirequest.adminMessage
              ? unirequest.adminMessage
              : "";
            this.faSubject = unirequest.faSubject;
            this.proposalFile = unirequest.proposalFile;
            this.registerDate = unirequest.registerDate;
            this.requestsCode = unirequest.requestsCode
              ? unirequest.requestsCode
              : "";
            this.researcher = unirequest.researcher;
            this.revision = unirequest.revision ? unirequest.revision : 0;
            this.rejectionIds = unirequest.rejectionIds
              ? unirequest.rejectionIds.map((x) => x._id)
              : [];
            this.university = unirequest.university;
            this.status = unirequest.status;
            this.statusEn = unirequest.statusEn;
            this.rejections = unirequest.rejectionIds
              ? unirequest.rejectionIds.map((x) => x.name)
              : [];
            try {
              document.body.classList.toggle("sidebar-minimized");
              document.body.classList.toggle("brand-minimized");
              this.toast(
                "در صورت نیاز به منو، میتوانید از علامت موجود در سمت راست صفحه استفاده کنید"
              );
            } catch (err) {
              console.log(err);
            }
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            setTimeout(() => {
              this.show = true;
              this.pageLoaded = true;
            }, 200);

            this.fileBusy = false;
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
          });
      }

      this.fileBusy = false;
    },
    hideModal(type) {
      // NOTE (m-hideModal) to hide loading
      this.$refs[type].hide();
    },
    computedVariant(seed) {
      // REVIEW
      let variant = [
        "primary",
        "secondary",
        "success",
        "warning",
        "danger",
        "dark",
        "info",
        "light",
      ];
      return variant[seed % 8];
    },
    submit() {
      this.$bvModal.show("loading");
      const status = this.situationsOptions.filter(
        (x) => x.id == this.decision
      )[0].eng;
      if (status != "rejected") this.rejectionIds = [];
      this.$http
        .patch(
          `${this.baseUrl}/setad/admin/researcherUniRequest/decision/${this.$route.params.id}`,
          {
            status: status,
            adminMessage:
              this.decision == 2 || this.decision == 4
                ? this.adminMessage
                : undefined,
            description: this.description,
            rejectionIds: this.rejectionIds,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        ) // REVIEW
        .then((res) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          if (res.status == 200) {
            this.description = "";
            this.adminToReferee = "";
            this.toast(res.data, "success");
            window.location.reload();
          }
        })
        .catch((err) => {
          this.$bvModal.hide("loading");
          this.isLoaded = true;
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
  },
  computed: {
    disableSubmit() {
      if (this.decision) {
        if (this.decision == 2) {
          if (!this.adminMessage) return true;
          else return false;
        }
        if (this.decision == 6 && !this.rejectionIds.length) return true;
        return false;
      } else return true;
    },
  },
  mounted() {
    this.onMounted();
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
};
</script>
<style lang="scss">
.selected-referees {
  border: 1px solid grey;
  border-radius: 5px;
  margin-bottom: 10px;
  &__tags {
    border: 1px solid grey;
    border-radius: 5px;
    padding: 8px 12px;
    .tag {
      padding: 5px;
      margin: 5px;
    }
  }
}
</style>
<style lang="scss" scoped>
.color {
  background-color: #0c4961;
  color: white;
}

.select2-container {
  width: 100% !important;
  padding: 0;
}

.select2 {
  width: 100% !important;
}

select {
  min-width: max-content;
  width: 100%;
}

.required {
  color: red;
}

.done {
  color: green;
}
.btn-dark {
  h5 {
    color: #fff !important;
  }
  background-color: #4b285d !important;
  border-color: #4b285d !important;
}
.btn-light {
  h5 {
    color: #fff !important;
  }
  background-color: #63317c !important;
  border-color: #63317c !important;
}
.btn-warning {
  h5 {
    color: #fff !important;
  }
  background-color: #8341a4 !important;
  border-color: #8341a4 !important;
}
.btn-info {
  h5 {
    color: #fff !important;
  }
  background-color: #a557cb !important;
  border-color: #a557cb !important;
}
.btn:hover {
  h5 {
    color: #fff !important;
  }
  background-color: #999999 !important;
  border-color: #b173a2 !important;
}

.table-column {
  min-width: 100px;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #8341a4;
  border-bottom: 1px solid #8341a4;
}
.btn-secondary {
  background-color: #83819b;
  border-color: #9b8195;
}

#vs1__listbox {
  text-align: right;
  direction: rtl;
}
</style>
<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
strong {
  color: #fff !important;
}
</style>
